import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { APIService } from 'src/app/core/api/general.service';
import { ItineraryService } from '../../search-result/services/itinerary.service';
import { LayoutService } from 'src/app/layout/services/layout.service';
import { OptionType } from 'src/app/core/enums/enums';
import { ItineraryHistoryService } from '../services/itinerary-history.service';

@Injectable()
export class ItineraryHistoryGuard implements CanActivate {
  constructor(
    private api: APIService,
    private itineraryService: ItineraryService,
    private itineraryHistoryService: ItineraryHistoryService,
    private layoutService: LayoutService
  ) {}

  loadItineraryHistory(pnr: string, gds: string) {
    return this.api.getItineraryClassicHistory(pnr, gds).pipe(
      map((response) => {
        this.layoutService.dispatchChangeBreadcrumb(pnr, OptionType.ItineraryHistory);
        this.itineraryHistoryService.dispatchLoadItineraryHistorySuccess(response);
        return !!response;
      }),
      catchError((response) => {
        this.itineraryService.dispatchGenericError(response);
        this.itineraryService.navigateToWithParams('itinerary/info');
        return of(false);
      })
    );
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.loadItineraryHistory(route?.queryParams?.pnr, route?.queryParams?.gds);
  }
}
